export const getTagSetFromGroupedKey = ({
  verticalResponse
}: {
  verticalResponse?: IProjectFlowResponse
}): Record<
  string,
  {
    tag: string
    tagField: string
    isAssignment?: boolean
  }
> => {
  if (!verticalResponse) return {}
  let keySet: Record<
    string,
    {
      tag: string
      tagField: string
      isAssignment?: boolean
    }
  > = {}
  verticalResponse?.response?.forEach(rootItem => {
    rootItem?.body?.forEach(rootBody => {
      rootBody?.group?.dataset?.forEach(datasetItem => {
        if (datasetItem?.id && datasetItem?.tag) {
          keySet = {
            ...keySet,
            [datasetItem?.id]: {
              tag: datasetItem?.tag as string,
              tagField: datasetItem?.tagField as string,
              isAssignment: rootBody?.group?.isMultiSelect
            }
          }
        }

        if (Number(datasetItem.body?.length) > 0) {
          datasetItem.body?.forEach((subIt: IProjectBody) => {
            if (subIt?.id && subIt?.tag) {
              keySet = {
                ...keySet,
                [subIt?.id]: {
                  tag: subIt.tag as string,
                  tagField: subIt?.tagField as string,
                  isAssignment: rootBody?.group?.isMultiSelect
                }
              }
            }
          })
        }
      })
    })
  })
  return keySet
}
